'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamsReportsMenu = require('./CamsReportsMenu');

var _CamsReportsMenu2 = _interopRequireDefault(_CamsReportsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamsReportsMenu2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamsReportsMenu/index.js
// module id = 274
// module chunks = 0